<template>
  <div id="datainfo">
        <div class="large-12 medium-12 small-12 columns">
        <div v-on:click="states.mainView = !states.mainView; states.datadetailView = !states.datadetailView">
        <img class="leftIco inline" src="graphics/ico_data.png" /> <span class="midleLabel inline fet">Dáta - aktuálne čerpáte</span>

            <div class="row">
                <div class="large-12 medium-12 small-12 columns">
                    <div class="left cre-detail"><strong> {{dataTitle}} </strong></div>
                </div>
            </div>
            <div class="progress-bar" v-if="baseView.pBar && !baseView.dataInfinite">
                <div class="vonkajsi">
                    <div class="vnutorny shadow" v-bind:style="{ width: posPercentage + '%' }"> <span class="inner-text text-left">{{baseView.pgLeftText}}</span> </div>
                    <div class="vnutorny-right" v-bind:style="{ width: negPercentage + '%' }"> <span class="inner-text text-right-in">{{ baseView.pgVal }}</span>
                </div>
            </div> <span class="inner-text text-left-out">{{baseView.pgLeftText}}</span> <span class="inner-text text-right">{{ baseView.pgVal }}</span> </div>
            <div class="progress-bar" style="position:relative;"  v-if="baseView.pBar && baseView.dataInfinite"><span class="inner-text text-right-in">{{ baseView.pgVal }}</span>
                <div class="vnutorny" style="width: 51%">
                    <div class="opacity-grad"><span class="inner-text text-left-inf">{{ baseView.pgLeftText }}</span></div>
                </div>
            </div>                               
            <div v-if="!baseView.pBar" class="row">
              <div class="large-12 medium-12 small-12 columns">
                <span class="inline cre-detail">Zostávajúce voľné dáta</span>
                <span class="right">{{baseView.bucketRest}}</span>
              </div>
             </div>
            </div>
              <div class="row">
              <div class="large-12 medium-12 small-12 columns">
                <span class="inline cre-detail" v-html="baseView.stopProlong ? 'Dátum obnovenia' : 'Platí do'" />
                <span class="right">{{baseView.gigaValidity}}</span>
              <a class="actions action" v-if="baseView.addToGiga" v-on:click="states.creditActionView = true, states.creditAction.type = 'add'">{{baseView.addTextGiga}}</a>                        
              </div>
              <div class="large-12 medium-12 small-12 columns" v-if="baseView.prolVisible">
                  <span class="inline cre-detail">Automatické predĺženie</span>
                  <span class="right">{{baseView.prolState}}</span>
              <a class="actions action" v-if="baseView.stopProlong" v-on:click="states.creditActionView = true, states.creditAction.type = 'stop'">Vypnúť automatické predĺženie</a>                        
              </div>
              </div>

        <a class="actions action" v-if="baseView.add200" v-on:click="states.creditActionView = true, states.creditAction.type = 'add', states.creditAction.command = 'DC500'">Dokúpiť 1,5 GB za 1,20 €</a>        
        <a class="actions action" v-if="baseView.add300" v-on:click="states.creditActionView = true, states.creditAction.type = 'add', states.creditAction.command = 'DC1000'">Dokúpiť 3 GB za 1,20 €</a>        
    </div>      
    <div v-html="streamOnDiv"></div>
    <div v-html="chatDiv"></div>
    <div v-html="socialDiv"></div>
    <div class="large-12 medium-12 small-12 columns" v-show="nextLink" v-on:click="states.mainView = !states.mainView; states.datadetailView = !states.datadetailView">
      <div class="next-link">
        <span class="inline mActive fet">Vaše ďalšie balíčky<img class="inline" src="graphics/ico_arrow_next.png"/></span>          
      </div>
    </div>
    </div>      
    
</template>

<script>
import moment from 'moment'
import { orchDataConsumption } from '@/services'

export default {
  name: 'detail',
  props: ['productdetail', 'tplData', 'states', 'filterBouquet', 'typeExists'],
  data () {
    return {
      msg: 'Datainfo',
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      baseView: {
        add200: false, add300: false, pBar: true, pgPercentage: 0, pgVal: '', addToGiga: false, stopProlong: false, pgLeftText: "Internet", prolState: "zapnuté",
        gigaValidity: moment(this.productdetail.timeStamp).format('D.M.YYYY') + ' 23:59', prolVisible: false, bucketRest: "0 MB", addTextGiga: "Dokúpiť 500 MB za 1 €", dataInfinite: false
      },
      dataTitle: "Internet v mobile na deň za " + moment(this.productdetail.timeStamp).format('D.M.YYYY'),
      namesMap: {"GIGA1W":"Raz Giga", "GIGA1M":"Vždy Giga", "GIGA2":"Vždy 2 Giga", "StreamOn Data Unlmtd":"Stream On", "StreamOn Data 200":"Stream On 200 MB", "GIGA6":"Dáta na rok 6 GB", "GIGA24":"Dáta na rok 24 GB", "GIGADEN":"Giga Deň",
      "SW Data":"Dáta pre blízkych", "Magenta Data":"Darované dáta z Magenta 1", "GIGAZIMNY":"Giga akcia", "GIGA4":"4 Giga akcia", "FridayUnLtd": "Nekonečné piatky", "GIGA3":"Vždy Giga (1,5 + 1,5 GB)", "GIGA5":"Vždy 2 Giga (2,5 + 2,5 GB)"
      }, 
      streamOnDiv: "",
      chatDiv: "",
      socialDiv: "",
      moment: moment,
      orchDataConsumption: orchDataConsumption,
      pkgCount: 0
    }
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.mainView = true 
    that.states.datadetailView = false
    }
    if (_.isObject(this.tplData.package.name)) {
      _.assign(this.namesMap, this.tplData.package.name)
    }

    var dataPackage = '', dpIdent = {}, dpSource = "SURF1 Data"
    var pkgCount = 0
    const SU1_0 = this.filterBouquet('SU1_0');
    const currencyBq = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataCurrencyDC' });

    if (!_.isEmpty(currencyBq)) {
      if (!_.isEmpty(SU1_0)) {
        dpSource = 'SU1_0';
        dpIdent = null;
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage' })[0]
      if (thisPkg.buckets.endDate) {
        if ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)) && !_.isEmpty(String(thisPkg.buckets.value))) {
          dataPackage = thisPkg.buckets.name
          dpIdent = _.clone(thisPkg)
          dpSource = "Free Data"
          pkgCount ++;
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageDC' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageDC' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp))) && (thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
        dataPackage = thisPkg.buckets.name
        dpIdent =  _.clone(thisPkg);
        dpSource = "SURF1 Data"
        pkgCount ++;
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage2' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp))) && (thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
        pkgCount ++;
        if ((_.isEmpty(dpIdent)) || ((dpIdent.buckets.endDate) && (moment(thisPkg.buckets.endDate) < (moment(dpIdent.buckets.endDate))))){
          dataPackage = thisPkg.buckets.name
          dpIdent =  _.clone(thisPkg)
          dpSource = "Free Data 2"
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage3' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp))) && (thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
        if ((thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
          pkgCount ++;
        }
        if ((_.isEmpty(dpIdent)) || ((dpIdent.buckets.endDate) && (moment(thisPkg.buckets.endDate) < (moment(dpIdent.buckets.endDate))))) {
          dataPackage = thisPkg.buckets.name
          dpIdent =  _.clone(thisPkg)
          dpSource = "Free Data 3"
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage5' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackage5' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp))) && (thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
        if ((thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
          pkgCount ++;
        }
        if ((_.isEmpty(dpIdent)) || ((dpIdent.buckets.endDate) && (moment(thisPkg.buckets.endDate) < (moment(dpIdent.buckets.endDate))))) {
          dataPackage = thisPkg.buckets.name
          dpIdent =  _.clone(thisPkg)
          dpSource = "Free Data 5"
        }
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'MagentaDataPackage' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'MagentaDataPackage' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp))) && (thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
        dataPackage = thisPkg.buckets.name
        dpIdent =  _.clone(thisPkg)
        dpSource = "Magenta Data"
        pkgCount ++;
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageBOND' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageBOND' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)))) {
        dataPackage = thisPkg.buckets.name
        dpIdent =  _.clone(thisPkg)
        dpSource = "Free Data 6"
        pkgCount ++;
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackagePD' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp)))) {
        if ((thisPkg.buckets.name === "2D_UnLtd" && ((_.isEmpty(dpIdent)) || ((dpIdent.buckets.endDate) && (moment(thisPkg.buckets.endDate) < (moment(dpIdent.buckets.endDate)))))) || (thisPkg.buckets.name !== "2D_UnLtd")) {
        dataPackage = thisPkg.buckets.name
        dpIdent =  _.clone(thisPkg)
        dpSource = "Promo Data"
        }
        pkgCount ++;
      }
    }

    if (!_.isEmpty(_.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' }))) {
      var thisPkg = _.filter(this.productdetail.product.subscriberWallets, { 'type': 'DataPackageSSD' })[0]
      if ((thisPkg.buckets.endDate) && ((moment(thisPkg.buckets.endDate)) > (moment(this.productdetail.timeStamp))) && (thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
        if ((thisPkg.buckets.value != "") && (thisPkg.buckets.value != 0)) {
          pkgCount ++;
        }
        if ((_.isEmpty(dpIdent)) || ((dpIdent.buckets.endDate) && (moment(thisPkg.buckets.endDate) < (moment(dpIdent.buckets.endDate))))) {
          dataPackage = thisPkg.buckets.name
          dpIdent =  _.clone(thisPkg)
          dpSource = "Internal Free Data"
        }
      }
    }

    var arrayDataBq = this.filterDataBouquet(true)
    this.pkgCount = pkgCount + arrayDataBq.length
    if ((this.pkgCount === 0) || (this.pkgCount !== 0 && this.typeExists.internet && arrayDataBq.length === 0)) {
      this.states.dataHide = true;
    }
    this.$emit('dataCount', this.pkgCount);

    if ((!_.isEmpty(arrayDataBq)) && (dpSource !== "Promo Data")) {

      this.baseView.pBar = false
      this.dataTitle = this.pkgNameRead(arrayDataBq[0].name)

      this.$store.state.currDataPackage = arrayDataBq[0].name

      this.baseView.gigaValidity = moment(arrayDataBq[0].endDate).format('D.M.YYYY H:mm')
      this.baseView.bucketRest = (Math.round((arrayDataBq[0].value) / 10.24) / 100).toString().replace(/\./, ',') + " MB"
    } else {
      if (this.states.rplnRel == "P") {
// Pecka
        if (dpSource === "Promo Data") {
        this.$store.state.currDataPackage = dpIdent.buckets.name 
        this.dataTitle = this.pkgNameRead(dpIdent.buckets.name)
        this.baseView.gigaValidity = moment(dpIdent.buckets.endDate).format('D.M.YYYY H:mm')
        this.baseView.pgVal = " neobmedzene"
        this.baseView.dataInfinite = true;
        } else if (_.isEmpty(dpIdent) && !_.isEmpty(currencyBq)) {
          const calcCurrObj = currencyBq[0];
          var maxSu = parseInt(calcCurrObj.bucketSize);
          var suValue = calcCurrObj.buckets.value || maxSu;
          this.states.dataHide = false;
          if ((maxSu - suValue) > 0) {
            if (suValue > maxSu) { suValue = maxSu }
            this.baseView.pgVal = ((maxSu - suValue) / 100000).toFixed(2).toString().replace(/\./, ',') + " € / " + ((Math.round(maxSu / 1000) / 100).toFixed(2)).toString().replace('.', ',')  + " €"
            this.baseView.pgPercentage = 100 - ((suValue / maxSu) * 100)
          } else {
            this.baseView.pgVal = "0 €"
            this.baseView.pgPercentage = 0
          }
        } else {
  // ine baliky ako denne Pecka
        var dataBuquetRaw = this.filterBouquet(dpSource)
        this.baseView.pgVal = "0 MB"
        this.baseView.pgPercentage = 0
        if (!_.isEmpty(dataBuquetRaw)) { 
          if ((moment(this.productdetail.timeStamp)) < moment(dpIdent.buckets.endDate)) {
            if (dpIdent.buckets.name !== 'DC500' && dpIdent.buckets.name !== 'DC1000') {
              this.baseView.gigaValidity = moment(dpIdent.buckets.endDate).format('D.M.YYYY H:mm')
            } else {
              if (dpIdent.buckets.value < 1500) { this.baseView.add200 = true }
            }
            this.baseView.pgLeftText = "Prenesené z voľných"
            this.dataTitle = this.pkgNameRead(dpIdent.buckets.name)

            this.$store.state.currDataPackage = dpIdent.buckets.name

            this.baseView.pgVal = this.orchDataConsumption(dpIdent.bucketSize, dpIdent.buckets.value)
            this.baseView.pgPercentage = 100 - (dpIdent.buckets.value / (dpIdent.bucketSize || 1)) * 100

            if ((/giga2(?!4)|giga1(?!w)|giga3|giga5/i).test(dpIdent.buckets.name)) {
            this.states.creditAction.command = dpIdent.buckets.name
              this.baseView.prolVisible = true
              // if (dpIdent.buckets.name.indexOf('ff') !== -1) {
              //   this.baseView.prolState = "vypnuté"
              //   this.baseView.stopProlong = false
              // } else {
              //     this.baseView.prolState = "zapnuté"
              //     this.baseView.stopProlong = true
              // }
              if (dpIdent.buckets.nextChargeDate && (moment(dpIdent.buckets.nextChargeDate) > moment(this.productdetail.timeStamp))) {
                this.baseView.prolState = "zapnuté"
                this.baseView.stopProlong = true
              } else {
                this.baseView.prolState = "vypnuté"
                this.baseView.stopProlong = false
              }
              if (dpIdent.buckets.value < 1500) {
                this.baseView.addToGiga = true
            }
          }
          if ((/giga24|giga6/i).test(dpIdent.buckets.name)) {
            this.baseView.addTextGiga = "Dokúpiť 1 GB za 3 €"
            this.states.creditAction.command = dpIdent.buckets.name
            if (dpIdent.buckets.value < 1500) {
              this.baseView.addToGiga = true
            }
          }
        }
        }
      }
    }
      // if (this.states.rplnRel == "T") {
    else {      
      this.states.dataHide = true

// T karta   
        if (dpSource === "Promo Data") {
        this.$store.state.currDataPackage = dpIdent.buckets.name 
        this.states.dataHide = false
        this.dataTitle = this.pkgNameRead(dpIdent.buckets.name)
        this.baseView.gigaValidity = moment(dpIdent.buckets.endDate).format('D.M.YYYY H:mm')
        this.baseView.pgVal = " neobmedzene"
        this.baseView.dataInfinite = true
        } else if (_.isEmpty(dpIdent) && !_.isEmpty(currencyBq) && this.states.rplnRel == "T") {
          const calcCurrObj = currencyBq[0];
          var maxSu = parseInt(calcCurrObj.bucketSize);
          var suValue = calcCurrObj.buckets.value || maxSu;
          this.states.dataHide = false;

          if (suValue > maxSu) { suValue = suValue / 2 }
          if (suValue > maxSu) { suValue = maxSu }

          if ((maxSu - suValue) >= 0) {
            this.baseView.pgVal = ((maxSu - suValue) / 100000).toFixed(2).toString().replace(/\./, ',') + " € / " + ((Math.round(maxSu / 1000) / 100).toFixed(2)).toString().replace('.', ',')  + " €"
            this.baseView.pgPercentage = 100 - ((suValue / maxSu) * 100)
          } else {
            this.baseView.pgVal = "0 €"
            this.baseView.pgPercentage = 0
          }
        } else {
            // ine baliky ako denne T karta
            var dataBuquetRaw = this.filterBouquet(dpSource)
            this.baseView.pgVal = "0 MB"
            this.baseView.pgPercentage = 0
            if (!_.isEmpty(dataBuquetRaw)) { 
              if ((dpIdent.buckets) && (dpIdent.buckets.endDate) && ((moment(this.productdetail.timeStamp)) < moment(dpIdent.buckets.endDate))) {
                this.states.dataHide = false
                if (dpIdent.buckets.name !== 'DC500' && dpIdent.buckets.name !== 'DC1000') {
                  this.baseView.gigaValidity = moment(dpIdent.buckets.endDate).format('D.M.YYYY H:mm')
                } else {
                  if (dpIdent.buckets.value < 1500 && this.states.rplnRel == "T") { this.baseView.add300 = true }
                }
                this.baseView.pgLeftText = "Prenesené z voľných"
                this.dataTitle = this.pkgNameRead(dpIdent.buckets.name)

                this.$store.state.currDataPackage = dpIdent.buckets.name

                if (dpIdent.buckets.value > dpIdent.bucketSize) { dpIdent.buckets.value = (dpIdent.bucketSize || 1) }

                this.baseView.pgVal = this.orchDataConsumption(dpIdent.bucketSize, dpIdent.buckets.value)
                this.baseView.pgPercentage = 100 - (dpIdent.buckets.value / (dpIdent.bucketSize || 1)) * 100

              if ((/30d_1gb|30d_2gb|30d_3gb|30d_4gb|30d_5gb|30d_6gb|30d_10gb(?!free)|10d_unltd/i).test(dpIdent.buckets.name)) {
                this.states.creditAction.command = dpIdent.buckets.name
                  this.baseView.prolVisible = true
                  // if (dpIdent.buckets.name.indexOf('ff') !== -1) {
                  //   this.baseView.prolState = "vypnuté"
                  //   this.baseView.stopProlong = false
                  // } else {
                  //   this.baseView.prolState = "zapnuté"
                  //   this.baseView.stopProlong = true
                  // }
                  if (dpIdent.buckets.nextChargeDate && (moment(dpIdent.buckets.nextChargeDate) > moment(this.productdetail.timeStamp))) {
                    this.baseView.prolState = "zapnuté"
                    this.baseView.stopProlong = true
                  } else {
                    this.baseView.prolState = "vypnuté"
                    this.baseView.stopProlong = false
                  }
                if (dpSource == "Internal Free Data") {
                  this.baseView.dataInfinite = true
                  this.baseView.pgVal = " neobmedzene"
                  this.baseView.pgLeftText = "Internet"
                } else {
                  this.baseView.dataInfinite = false
                }
              }
            }
          }
        }
      }
    }

    if (!_.isEmpty(_.filter(this.filterDataBouquet(), { 'name': 'StreamOn Data Unlmtd' }))) {
      this.streamOnDiv = this.getStreamOn(_.filter(this.filterDataBouquet(), { 'name': 'StreamOn Data Unlmtd' })[0])
    }
    if (!_.isEmpty(_.filter(this.filterDataBouquet(), { 'name': 'Free Data CHAT' }))) {
      this.chatDiv = this.getChat(_.filter(this.filterDataBouquet(), { 'name': 'Free Data CHAT' })[0])
    }
    if (!_.isEmpty(_.filter(this.filterDataBouquet(), { 'name': 'Free Data SOCIAL' }))) {
      this.socialDiv = this.getSocial(_.filter(this.filterDataBouquet(), { 'name': 'Free Data SOCIAL' })[0])
    }

  },
  mounted: function() {
    this.$store.state.namesMap = this.namesMap
  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    },
    negPercentage: function() { 
      return 100 - this.posPercentage

    },
    posPercentage: function() {
      var checkPerc = this.baseView.pgPercentage
      if (this.baseView.pgPercentage < 0)
        {
          checkPerc = 0
        }
      if (this.baseView.pgPercentage > 100)
        {
          checkPerc = 100
        }
      return checkPerc  
    },
    nextLink: function() {
      if ((this.pkgCount > 1) && (!this.states.datadetailView)) {
        return true
      } else {
        return false
      }
    }
  }, 
  methods: {
      filterDataBouquet: function (notSO) {
        var that = this
        var targetObj = {}, res = [], namesList = ['StreamOn Data 200', 'Free Data CHAT', 'Free Data SOCIAL', 'SW Data', 'StreamOn Data Unlmtd']
        var wallets = this.productdetail.product.subscriberWallets
        if (!Array.isArray(wallets)) {
          wallets = [wallets]
        }
        wallets.forEach(function(v){
          if (v.type === undefined) {
            targetObj = v;
          }
        })
        if (!Array.isArray(targetObj.buckets)) {
          targetObj.buckets = [targetObj.buckets]
        }
        targetObj.buckets.forEach(function(tv){
          if (namesList.indexOf(tv.name) !== -1) {
            if ((moment(that.productdetail.timeStamp) < moment(tv.endDate)) && (tv.value >= 1500)) {
              if (notSO) {
                if ((tv.name !== "StreamOn Data Unlmtd") && (tv.name !== "Free Data SOCIAL") && (tv.name !== "Free Data CHAT")) {
                  res.push(tv)
                }
              } else {
                res.push(tv)
              }
            }
          }
        })
        var mOrder = ['GIGAZIMNY', 'StreamOn Data 200', 'Free Data CHAT', 'Free Data SOCIAL', 'SW Data', 'StreamOn Data Unlmtd']
        res.sort(function (a, b) {
							var nameB = mOrder.indexOf(a['name']),
							    nameA = mOrder.indexOf(b['name'])
							if (nameA < nameB) {
								return 1;
							}
							if (nameA > nameB) {
								return -1;
							}
							return 0;
            });
        return res
      },
      getStreamOn: function(sObj) {
        return '<div class="large-12 medium-12 small-12 columns""><p></p>'+
                        '<span class="inline cre-detail"><strong>Stream On</strong></span>'+
                        '<span class="right">Neobmedzene video a hudba</span>'+
                    '</div>'+
                    '<div class="large-12 medium-12 small-12 columns">'+
                        '<span class="inline cre-detail">Platí do</span>'+
                        '<span class="right">'+moment(sObj.endDate).format('D.M.YYYY H:mm')+'</span>'+
                    '</div>'
      },
      getChat: function(sObj) {
        var thisProl = "vypnuté"
        if ((sObj.nextChargeDate) && (moment(sObj.nextChargeDate) > moment(this.productdetail.timeStamp))) { thisProl = "zapnuté" }
        return '<div class="large-12 medium-12 small-12 columns""><p></p>'+
                        '<span class="inline cre-detail"><strong>'+this.pkgNameRead(sObj.name)+'</strong></span>'+
                    '</div>'+
                    '<div class="large-12 medium-12 small-12 columns">'+
                        '<span class="inline cre-detail">Platí do</span>'+
                        '<span class="right">'+moment((sObj.endDate) || (sObj.nextChargeDate)).format('D.M.YYYY H:mm')+'</span>'+
                    '</div>'+
                    '<div class="large-12 medium-12 small-12 columns">'+
                        '<span class="inline cre-detail">Automatické predĺženie</span>'+
                        '<span class="right">'+thisProl+'</span>'+
                    '</div>'
      },
      getSocial: function(sObj) {
        var thisProl = "vypnuté"
        if ((sObj.nextChargeDate) && (moment(sObj.nextChargeDate) > moment(this.productdetail.timeStamp))) { thisProl = "zapnuté" }
        return '<div class="large-12 medium-12 small-12 columns""><p></p>'+
                        '<span class="inline cre-detail"><strong>'+this.pkgNameRead(sObj.name)+'</strong></span>'+
                    '</div>'+
                    '<div class="large-12 medium-12 small-12 columns">'+
                        '<span class="inline cre-detail">Platí do</span>'+
                        '<span class="right">'+moment((sObj.endDate) || (sObj.nextChargeDate)).format('D.M.YYYY H:mm')+'</span>'+
                    '</div>'+
                    '<div class="large-12 medium-12 small-12 columns">'+
                        '<span class="inline cre-detail">Automatické predĺženie</span>'+
                        '<span class="right">'+thisProl+'</span>'+
                    '</div>'
      },
      pkgNameRead: function(orig) {
        var res = orig;
        if ((/30d_1gb/i).test(orig)) {
          res = "30D_1GB"
        }
        if ((/30d_3gb/i).test(orig)) {
          res = "30D_3GB"
        }
        if ((/30d_4gb/i).test(orig)) {
          res = "30D_4GB"
        }
        if ((/30d_5gb/i).test(orig)) {
          res = "30D_5GB"
        }
        if ((/30d_6gb(?!x)/i).test(orig)) {
          res = "30D_6GB"
        }
        if ((/30d_6gbx/i).test(orig)) {
          res = "30D_6GBx"
        }
        if ((/30d_10gb(?!free)|30d_10gb(?!x)/i).test(orig)) {
          res = "30D_10GB"
        }
        if ((/30d_10gbx/i).test(orig)) {
          res = "30D_10GBx"
        }
        if ((/30d_10gbfree/i).test(orig)) {
          res = "30D_10GBFREE"
        }
        if ((/10d_unltd/i).test(orig)) {
          res = "10D_UnLtd"
        }
        if ((/10d_chat/i).test(orig)) {
          res = "10D_CHAT"
        }
        if ((/10d_social/i).test(orig)) {
          res = "10D_SOCIAL"
        }
        if ((/free data social/i).test(orig)) {
          res = "FD-SOCIAL"
        }
        if ((/free data chat/i).test(orig)) {
          res = "FD-CHAT"
        }
        if ((/10d_1gb/i).test(orig)) {
          res = "10D_1GB"
        }
        if ((/freecalls21/i).test(orig)) {
          res = "FreeCalls21N"
        }
        if ((/giga24/i).test(orig)) {
          res = "GIGA24"
        }
        if ((/giga6/i).test(orig)) {
          res = "GIGA6"
        }
        if ((/giga2(?!4)/i).test(orig)) {
          res = "GIGA2"
        }
        if ((/giga1(?!w)/i).test(orig)) {
          res = "GIGA1M"
        }
        if ((/giga1w/i).test(orig)) {
          res = "GIGA1W"
        }
        if ((/giga4/i).test(orig)) {
          res = "GIGA4"
        }
        if ((/giga3/i).test(orig)) {
          res = "GIGA3"
        }
        if ((/giga5/i).test(orig)) {
          res = "GIGA5"
        }
        return this.namesMap[res] || res
      }
    }
}
</script>

<style scoped>
.next-link {
  text-transform: uppercase;
  padding: 1rem 3px 0.6rem;
  cursor: pointer;
}
.next-link img {
  height: 15px;
  position: relative;
  bottom: 3px;
  margin-left: 10px;
}
</style>
